'use strict';

var calendar = require('./calendar');

function inline (elem, calendarOptions) {
  var o = calendarOptions || {};

  o.appendTo = elem;
  o.associated = elem;

  var cal = calendar(o);
  cal.show();
  return cal;
}

module.exports = inline;



//////////////////
// WEBPACK FOOTER
// ./~/rome/src/inline.js
// module id = 281
// module chunks = 0